import React from 'react';
import { ActivityFeed } from './ActivityFeed';

export function StudioDashboardPage() {
  return (
    <div>
      <h1 className="text-2xl font-bold mb-4">Studio Dashboard</h1>
      <ActivityFeed />
    </div>
  );
}